import PropTypes from"prop-types";const propTypes={size:PropTypes.oneOf(["xs","sm","md","lg","xl"]),circle:PropTypes.bool};export default propTypes;